import React, { useContext } from "react";
import { Message } from "../../adapters/insights-agent/state/AppState.ts";
import { CopyIcon } from "../../ui-library/_icons/CopyIcon.tsx";
import { Button } from "../../ui-library/Button/Button.tsx";
import { makeCopyText } from "../MarkdownWithCitations/lib/makeCopyText.ts";
import styles from "./ChatMessages.module.css";
import { MessageContext } from "./MessageContext.tsx";
import { clx } from "../../utilities/clx.ts";

export const ActionBar: React.FC<{
  message: Pick<Message, "sender" | "value" | "citations" | "references">;
}> = (props) => {
  const { resendLastQuery } = useContext(MessageContext);
  return (
    <div
      className={`${styles.ActionsContainer} ${props.message.sender === "agent" ? styles.AlignLeft : styles.AlignRight}`}
      role="menubar"
    >
      <Button
        label={"Copy message content"}
        variant="transparent"
        className={clx([
          styles.ActionButton,
          props.message.sender === "agent" ? styles.Left : styles.Right,
        ])}
        onClick={() => {
          const copyText = makeCopyText(props.message);
          if (navigator.clipboard) {
            navigator.clipboard.writeText(copyText).then(
              () => {
                console.log("Copying to clipboard was successful!");
              },
              (err) => {
                console.error("Could not copy text: ", err);
              },
            );
          } else {
            try {
              // Fallback for older browsers
              console.warn(
                "Clipboard API not available. Using fallback method.",
              );
              const textArea = document.createElement("textarea");
              textArea.value = copyText;
              document.body.appendChild(textArea);
              textArea.select();
              document.execCommand("copy");
              document.body.removeChild(textArea);
              console.log(
                "Copying to clipboard (using the fallback method) was (probably) successful!",
              );
            } catch (e) {
              console.error("Fallback: Oops, unable to copy", e);
            }
          }
        }}
      >
        <CopyIcon />
      </Button>
      {resendLastQuery && (
        <Button
          label={"Resend last query"}
          aria-label="resend last query"
          variant="transparent"
          className={clx([
            styles.ActionButton,
            styles.RetryButton,
            props.message.sender === "agent" ? styles.Left : styles.Right,
          ])}
          onClick={resendLastQuery}
        >
          ↻
        </Button>
      )}
    </div>
  );
};
